export default __webpack_public_path__ + "static/media/brand2.23edba13.jpg";